// disabling eslint temporarily for legacy files until they can be refactored
/* eslint-disable */
import React from "react";
import { Spinner } from "../../../components/Spinner";
import { Col, Row } from "react-bootstrap";
import language from "../../utils/en.json";
import styles from "./text.module.scss";

/**
 * A generic text string display component
 * @param {Boolean} isLoading (Required) Whether the parent component is in a loading state
 * @param {Boolean} isError (Optional) Whether the parent is in an error state
 * @param {String} textContainerClass (Optional) A class to apply to the outer container of the component
 * @param {String} textRowClass (Optional) A class to apply to the row of the component (align-items-stretch, pt-1, mb-3, etc.)
 * @param {String} textString (Required) Text to display in the main text display
 * @param {Object} textStyle Styling to be applied to the text element
 * @param {String} textClass (Optional) Class to apply to the text element
 * @param {String} subTextType (Optional) The form of the sub-text to display. Currently supports: fractional, undefined (default)
 * @param {Object | Array} subTextStyle (Optional) Style to apply to the sub text. If using a fractional subText type, subTextStyle[0] is for numerator, subTextStyle[1] is for denominator
 * @param {Object | Array} subTextClass (Optional) Class to apply to the sub text. If using a fractional subText type, subTextClass[0] is for numerator, subTextClass[1] is for denominator
 * @param {String | Object} subText (Optional) Text to display below the main text. If fractional sub-text type, form as an object with keys: numerator, denominator
 */
export const Text = (props) => {
  const {
    isLoading,
    isError,
    textContainerClass,
    textRowClass,
    textString,
    textStyle,
    textClass,
    subTextType,
    subTextStyle,
    subTextClass,
    subText,
  } = props;

  return (
    <div
      className={
        textContainerClass ? textContainerClass : styles["text-container"]
      }
    >
      {isError || textString === undefined || textString === null ? (
        <div className={"no-data-label p-4"}>{language["GENERAL.NO_DATA"]}</div>
      ) : isLoading ? (
        <Spinner />
      ) : (
        <Row className={textRowClass ? textRowClass : "align-items-center"}>
          <Col>
            <p
              className={textClass ? textClass : styles.text}
              style={textStyle}
            >
              {textString}
            </p>

            {/* Fractional sub-text */}
            {subTextType === "fractional" &&
            subText &&
            subText.numerator &&
            subText.denominator ? (
              <div className={subTextClass ? subTextClass : styles.subText}>
                <span
                  className={
                    subTextClass && subTextClass.length ? subTextClass[0] : ""
                  }
                  style={
                    subTextStyle && subTextStyle.length ? subTextStyle[0] : ""
                  }
                >
                  {subText.numerator}
                </span>
                <span
                  className={
                    subTextClass && subTextClass.length ? subTextClass[1] : ""
                  }
                  style={
                    subTextStyle && subTextStyle.length ? subTextStyle[1] : ""
                  }
                >
                  /{subText.denominator}
                </span>
              </div>
            ) : (
              subText && (
                <>
                  {/* Regular string sub-text */}
                  <p
                    className={subTextClass ? subTextClass : styles.subText}
                    style={subTextStyle}
                  >
                    {subText}
                  </p>
                </>
              )
            )}
          </Col>
        </Row>
      )}
    </div>
  );
};
